import { isValid as _isValidCNPJ } from './checkCNPJ';
import { isValid as _isValidCPF } from './checkCPF';

/**
 * Helper function to check if a CNPJ is valid.
 * @param {String} cnpj The value.
 */
export const isValidCNPJ = cnpj => _isValidCNPJ(cnpj);

/**
 * Helper function to check if a CPF is valid.
 * @param {String} cpf The value.
 */
export const isValidCPF = cpf => _isValidCPF(cpf);

/**
 * Helper regex to test if an e-mail is valid.
 * @param {String} email The value.
 */
export const isValidEmail = email => {
    return (
        email &&
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            email,
        )
    );
};

/**
 * Helper function to test if a password is valid.
 * It must have Uppercase letters and Numbers
 * @param {String} password The value.
 * @param {Number} length Optional field for the min number of characters.
 */
export const isValidPassowrd = (password, length = 8) => {
    const patt = new RegExp(`^(?=.*[A-Z])(?=.*[0-9])(?=.{${length},})`);
    return password && patt.test(password);
};

/**
 * Helper function to test if a CEP is valid.
 * @param {String} cep The value.
 */
export const isValidCEP = cep => {
    const patt = new RegExp('\\d{5}[-]\\d{3}');
    return cep && patt.test(cep);
};

/**
 * Helper function to test if a PHONE is valid.
 * @param {String} phone The value.
 */
export const isValidPhone = phone => {
    const patt = new RegExp('\\(\\d{2}\\) \\d{4,5}-\\d{4}');
    return phone && patt.test(phone);
};

/**
 * Helper function to check if the errors object is empty.
 * @param {*} errors
 */
export const isFormValid = errors => {
    for (let key in errors) {
        if (errors[key] !== undefined) {
            return false;
        }
    }
    return true;
};

/**
 * Helper function to remove the readonly attribute added to a field in order to remove the browser auto-complete.
 */
export const removeReadOnly = e => e.target.removeAttribute('readonly');
